export const ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const

export type MaybeUserWithRole = {
  role?: string | null
} | null | undefined

export function normalizeRole(role?: string | null): string | null {
  return typeof role === 'string' ? role.toUpperCase() : null
}

export function hasRole(roleOrUser: string | MaybeUserWithRole, required: string): boolean {
  const role = typeof roleOrUser === 'string' ? roleOrUser : roleOrUser?.role
  const normalizedRole = normalizeRole(role)
  const normalizedRequired = normalizeRole(required)
  if (!normalizedRole || !normalizedRequired) return false
  return normalizedRole === normalizedRequired
}

export function isAdmin(roleOrUser: string | MaybeUserWithRole): boolean {
  return hasRole(roleOrUser, ROLES.ADMIN)
}

export function isAdminUser(user: MaybeUserWithRole): boolean {
  return isAdmin(user)
}

